import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { AddStationForm } from "../features/stations/AddStationForm";

export function NewStationRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-2xl px-4 py-6">
      <h1 className="mb-4 text-2xl font-bold text-fg">{t("stations.add_title")}</h1>
      <AddStationForm onSuccess={() => setTimeout(() => navigate("/"), 1500)} />
    </div>
  );
}
